// extracted by mini-css-extract-plugin
export default {"melodyVideo":"dP-z","isFullWidth":"eP-z","landingPageVideo":"fP-z","play":"gP-z","iframeVideo":"hP-z","playHidden":"iP-z","fullwidth":"jP-z"};